import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PrivacyRoutingModule } from './privacy-routing.module';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { TermsOfUseComponent } from './terms-of-use/terms-of-use.component';
import { CookiePolicyComponent } from './cookie-policy/cookie-policy.component';

import { SharedModule } from '../shared/shared.module';


@NgModule({
	declarations: [
		PrivacyPolicyComponent,
		TermsOfUseComponent,
		CookiePolicyComponent
	],
  imports: [
    CommonModule,
    PrivacyRoutingModule,
		SharedModule
  ],
	exports: [
		PrivacyPolicyComponent,
		TermsOfUseComponent,
		CookiePolicyComponent
	]
})
export class PrivacyModule { }
